import React from "react";
import { Link } from "react-router-dom";
import { getUser } from "../../utils/session";

const CourseLockedScreen = ({ readchapter }) => {
  // Check if operations should be disabled (security_verification_status === '1')
  const user = getUser();
  const shouldDisableOperations = user?.security_verification_status === '1';

  return (
    <div className="entry-screen">
      <div className="logoText">
        <h3>Welcome Back to the <span>FTLSAE</span> Course</h3>
      </div>
      <strong className="d-block text-primary-s fw-normal py-2">
        <i className="fa fa-graduation-cap me-1"></i> Choose Wisely
      </strong>
      <br />
      <h2 className="fw-bold text-primary-s">
        Use the left side menu to select any completed chapter to review.
      </h2>
      <div className="action-buttons">
        <button
          name="btn"
          onClick={readchapter}
          className="btn course-start btn-primary-s px-4 py-3 my-4 w-100 text-white"
        >
          Review Completed Chapter
        </button>
        {!shouldDisableOperations && JSON.parse(sessionStorage.getItem('user')).test_status !== '1' && (
          <Link
            name="btn"
            to={'/course/course-result-card'}
            className="btn course-start btn-secondary-s px-4 py-3 my-4 w-100 text-white"
          >
            Retake Exam
          </Link>
        )}
       
      </div>
    </div>
  );
};

export default CourseLockedScreen;
